'use strict';

var gettext = require('mag-gettext').gettext;

module.exports =  [
    {
        name: gettext('always'),
        value: 0
    },
    {
        name: gettext('after 15 minutes'),
        value: 1000 * 60 * 15
    },
    {
        name: gettext('after 1 hour'),
        value: 1000 * 60 * 60
    },
    {
        name: gettext('after 2 hours'),
        value: 1000 * 60 * 60 * 2
    }
];
